export const CONVERSATION_STARTED = 'conversationStarted';
export const CONVERSATION_CLOSED = 'conversationClosed';
export const UNREAD_CONVERSATION_COUNT_CHANGED = 'unreadConversationCountChanged';
export const INPUT_STAGING = 'inputStaging';
export const CONTACT_ASSOCIATED = 'contactAssociated';
export const USER_INTERACTED_WITH_WIDGET = 'userInteractedWithWidget';
export const QUICK_REPLY_BUTTON_CLICK = 'quickReplyButtonClick';
export const WIDGET_LOADED = 'widgetLoaded';
export const WIDGET_CLOSED = 'widgetClosed';
export const USER_SELECTED_THREAD = 'userSelectedThread';
export const SDK_CLOSE_BUTTON_CLICK = 'sdkCloseButtonClick';
export const MIC_BUTTON_CLICK = 'micButtonClick';
export const MIC_BUTTON_STOP = 'micButtonStop';
export const PLAY_BUTTON_PLAY = 'playButtonPlay';
export const PLAY_BUTTON_PAUSE = 'playButtonPause';
export const SPEECH_POC_ACTIVE = 'speechPocActive';
export const AUDIO_PLAYBACK_STARTED = 'audioPlaybackStarted';
export const AUDIO_PLAYBACK_COMPLETE = 'audioPlaybackComplete';
export const SPEECH_TO_TEXT_RESULT = 'speechToTextResult';
export const MESSAGE_INPUT_STATE_CHANGED = 'messageInputStateChanged';